import '../scss/style.scss';
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import burgerToggler from './burger';
import sliderFlickering from "./slider-flickering";
import scrollMenu from "./scroll";

burgerToggler();
sliderFlickering();
scrollMenu();
